<template>
  <div class="bank-card-list" @click="handleChange">
    <div class="left">
      <div class="left-top">
        <div class="bank-card-img-wrap">
          <img
            class="bank-card-img"
            :src="require(`@/assets/style/bankLogo/${bankCard.bankName}.png`)"
            alt=""
          />
        </div>
        <span class="bank-card-name">{{ bankCard.bankName }}</span>
      </div>
      <div class="left-bottom">
        {{ bankCard.bankNumber && formatBankNumCard(bankCard.bankNumber) }}
      </div>
    </div>
    <div class="right">
      <van-radio
        checked-color="#1d70f7"
        :name="bankCard.id"
      />
    </div>
  </div>
</template>

<script>
import { formatBankNumCard } from "@/utils/utils.js";
export default {
  name: "BankCardList",
  props: {
    bankCard: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formatBankNumCard,
    };
  },
  async mounted() {},
  methods: {
    handleChange() {
      this.$store.commit("setBankInfo", this.bankCard);
      this.$emit("change", this.bankCard);
    },
  },
};
</script>

<style scoped lang="scss">
.bank-card-list {
  padding: 0px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background-image: url("@/assets/style/selectList-bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100px;
  color: #333333;
  position: relative;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;

    .left-top {
      display: flex;
      align-items: center;
      .bank-card-img-wrap {
        width: 32px;
        height: 32px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        margin-right: 8px;
        .bank-card-img {
          width: 26px;
          height: 26px;
        }
      }
      .bank-card-name {
        font-size: 16px;
        color: #333333;
      }
    }
  }
  .right{
    position: absolute;
    width: 100%;
    height: 100%;
    right: 0;
    padding-right: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ::v-deep{
      .van-radio{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
.radio-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
::deep(.van-radio-group) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
</style>
